import { Application } from '../../../../../application/application'

export function isProfileStep(application: Application) {
  return !application.completedProfileStep
}
